React = require 'react'
t = require('views/internal/recup-with-helpers')('boards_page_gold_banner')
_ = require 'underscore'

class GoldBannerComponent extends React.Component
  displayName: 'GoldBanner'

  render: t.renderable ->

    {
      hasGold
      invitedMemberNames
      localizedMonthsOfCreditMessage
      onDismissBanner
    } = @props

    if hasGold
      welcomeHeading = 'welcome heading-upgrade'
      tips = [
        {
          key: 'tip-power-ups',
          props: {
            url: 'https://trello.com/power-ups?utm_source=welcome-banner&utm_medium=inapp&utm_term=gold-subscribe'
          }
        },
        {
          key: 'tip-board backgrounds',
          props: {
            url: 'http://help.trello.com/article/818-changing-board-backgrounds?utm_source=welcome-banner&utm_medium=inapp&utm_term=gold-subscribe'
          }
        },
        {
          key: 'tip-premium stickers',
          props: {
            url: 'http://help.trello.com/article/817-trello-gold-user-guide?utm_source=welcome-banner&utm_medium=inapp&utm_term=gold-subscribe'
          }
        }
      ]
    else
      welcomeHeading = 'welcome heading-recommendation'
      tips = [
        {
          key: 'tip-these people joined'
          props: {
            invited_members: invitedMemberNames.join(', ')
          }
        },
        {
          key: 'tip-account settings',
          props: {
            url: '/my/billing?utm_source=welcome-banner&utm_medium=inapp&utm_term=gold-recommend',
          }
        },
        {
          key: 'tip-learn trello gold', props: {
            url: 'http://help.trello.com/article/817-trello-gold-user-guide?utm_source=welcome-banner&utm_medium=inapp&utm_term=gold-recommend',
          }
        }
      ]

    t.div '.gold-banner', =>
      t.button '.icon-lg.icon-close', onClick: onDismissBanner
      t.div '.gold-banner-content', =>
        t.div '.gold-banner-welcome-section', =>
          t.h1 '.gold-banner-welcome-heading', =>
            t.format welcomeHeading
          t.p '.gold-banner-welcome-subheading', =>
            if hasGold
              t.format 'welcome subheading-upgrade'
            else
              t.text localizedMonthsOfCreditMessage
        t.ol '.gold-banner-tip-list', =>
          _.map(tips, (tip, i) =>
            t.li '.gold-banner-tip-list-item', =>
              t.span '.gold-banner-tip-list-item-bullet', 'aria-hidden': true
              t.span '.gold-banner-tip-list-item-text', =>
                if tip.hasOwnProperty('props')
                  t.format tip.key, tip.props
                else
                  t.format tip.key
          )

module.exports = GoldBannerComponent



// WEBPACK FOOTER //
// ./app/scripts/views/member/gold-banner-component.coffee